import React, { useEffect, useState } from 'react';
import { Pagination as MUIPagination } from '@mui/material';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import colors from '../../../assets/styles/colors';
import commons from '../../../assets/styles/commons';

interface Props {
  totalRecords: number;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  rowsPerPage: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    number: {
      fontFamily: commons.fontFamily,
      fontSize: 32,
      '&:hover': {
        color: colors.primary.orange,
        opacity: 0.8,
      },
    },
  }),
);

const Pagination: React.FC<Props> = ({
  totalRecords,
  setCurrentPage,
  currentPage,
  rowsPerPage,
}) => {
  const numberPages = Math.ceil(totalRecords / rowsPerPage);

  const classes = useStyles();

  return (
    <>
      {numberPages >= 1 && (
        <Box component="div" className={classes.pagination}>
          <MUIPagination
            count={Number(numberPages)}
            page={Number(currentPage)}
            color="primary"
            className={classes.number}
            onChange={(_, page) => {
              console.log({ page, currentPage });
              setCurrentPage(Number(page));
            }}
          />
        </Box>
      )}
    </>
  );
};

export default Pagination;
